'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './dynamic-page-edit.routes';

export class DynamicPageEditComponent {
  constructor(DynamicPageService, Auth, $state, $stateParams, dialogs, StorageService, Upload, $q) {
    'ngInject';

    this.DynamicPageService = DynamicPageService;
    this.StorageService = StorageService;
    this.Auth = Auth;
    this.Upload = Upload;
    this.$q = $q;

    this.snippet = $stateParams.snippet;
    this.name = $stateParams.name;

    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["h1","h2","h3","h4","h5"],
      ["p","pre","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["indent","outdent"],
      ["undo","redo"],
      ["codeMirror"],
      ["archiveImageLink", "insertImage","insertLink","insertVideo"],
      ["backgroundColor","fontColor","fontName", "fontSize"]
    ];

    this.pageId = $stateParams.id;

    this.dialogs = dialogs;
    this.$state = $state;

    this.pageTemplate = {
      name: '',
      description: '',
      data: '',
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    this.page = angular.copy(this.pageTemplate);

    if (this.pageId) {
      this.DynamicPageService.get({id: this.pageId}, data => {
        this.page = data;
      }, err => {
        console.log('Could not load dynamic page from server');
      })
    } else {

      if (this.snippet) {
        try {
          this.page.data = require('../../../../components/html-page-snippets/'+this.snippet+".html");
        } catch(e) {
          console.log(e);
        }
      }

      if (this.name) {
        this.page.name = this.name;
      }

    }

    var that = this;

    this.dropHandler = function( file, insertAction ) {

      // validation
      if( !file.type.startsWith('image/') ) {
        // ignore other file than images
        return;
      }

      /* could check for file size: if( file.size > 500000 ) */

      var defer = that.$q.defer();

      that.Upload.upload({
        url: '/api/storage',
        data: {
          name: file.name,
          file: file,
          storageStrategy: 'local',
          isPublic: true,
          creationUser: that.Auth.getCurrentUserSync()._id,
          active: true
        }
      }).then((response) => {
        insertAction( "insertImage", "/api/storage/" + response.data, true );
        defer.resolve(true);
      }, (response) => {
        if (response.status > 0) {
          alert(response.status + ': ' + response.data);
          defer.reject();
        }
      });

      return defer.promise;

    };
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        this.page = angular.copy(this.pageTemplate);
        this.submitted = false;

        var actionString = (this.pageId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The page has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("dynamic-page-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      if (this.pageId) {  // Save changes on the current page
        this.DynamicPageService.update({id: this.pageId}, this.page, onSuccess, onError);
      } else { // Create a new page
        this.DynamicPageService.save(this.page, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.ap.dynamicPages.edit', [uiRouter])
  .config(routes)
  .component('dynamicPageEdit', {
    template: require('./dynamic-page-edit.html'),
    controller: DynamicPageEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/dynamic-pages/edit/dynamic-page-edit.component.js